export default __webpack_public_path__ + "static/media/vid_unlock.82723415.svg";